import React from "react";
function Projects () {
    return (
        <main>
            <section class="fullscreen d-flex align-items-center justify-content-center">
                <div class="col-9 col-sm-9 col-md-8 col-lg-9">
                    <h1 class="header text-center">UX Research</h1>
                    <div class="row">
                        <div class="project card color-1 col-lg">
                            <a href="/projects/moments">
                            <h2 class="card-title text-center">Moments</h2>
                            <img class="project card-image" src="img/MomentsMockup.png" alt="Moments mockup"></img>
                            </a>
                        </div>
                        <div class="project card color-2 col-lg">
                            <a href="/projects/musicroom">
                            <h2 class="card-title text-center">MusicRoom</h2>
                            <img class="project card-image" src="img/MusicroomMockup.png" alt="Musicroom mockup"></img>
                            </a>
                        </div>
                        <div class="project card color-1 col-lg">
                            <a href="/projects/sleepandsee">
                            <h2 class="card-title text-center">sleep&see</h2>
                            <img class="project card-image" src="img/sleep&seeMockup.png" alt="sleep&see mockup"></img>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section class="fullscreen d-flex align-items-center justify-content-center">
                <div class="col-9 col-sm-9 col-md-8 col-lg-9">
                    <h1 class="header text-center">UI & Web Design</h1>
                    <div class="row">
                        <div class="project card color-2  col-lg">
                            <a href="/projects/momentsui">
                            <h2 class="card-title text-center">Moments</h2>
                            <img class="project card-image" src="img/MomentsMockup2.png" alt="Moments mockup"></img>
                            </a>
                        </div>
                        <div class="project card color-1 col-lg">
                            <a href="/projects/sps">
                            <h2 class="card-title text-center">SPS Redesign</h2>
                            <img class="project card-image" src="img/SPSMockup.png" alt="SPS website mockup"></img>
                            </a>
                        </div>
                        <div class="project card color-2 col-lg">
                            <a href="/projects/scoolwise">
                            <h2 class="card-title text-center">Scoolwise</h2>
                            <img class="project card-image" src="img/ScoolwiseMockup.png" alt="Scoolwise mockup"></img>
                            </a>
                        </div>
                    </div>
                </div>
        </section>
        <section class="fullscreen d-flex align-items-center justify-content-center">
            <div class="col-9 col-sm-9 col-md-8 col-lg-9">
                <h1 class="header text-center">Figma Projects</h1>
                <div class="row">
                    <div class="project card color-1 col-lg">
                    <a href="https://www.figma.com/proto/zvXVMxyWw5euylaqA0SWrH/INFO-498-E-Group-1-Comic?page-id=0%3A1&type=design&node-id=1-368&viewport=1143%2C396%2C0.04&t=CNJ8vqPoG3AFx7Ny-9&scaling=contain&starting-point-node-id=1%3A368&show-proto-sidebar=1" target="_blank" rel="noopener noreferrer">
                        <h2 class="card-title text-center">Cultural Analysis Comic</h2>
                        <img class="project card-image" src="img/CulturalAnalysisComic.png" alt="Cultural analysis comic"></img>
                    </a>
                    </div>
                    <div class="project card color-2 col-lg">
                    <a href="https://www.figma.com/proto/O0K1mHys8KvdP0DSUlUJPt/Rhythm-game?page-id=60%3A63&type=design&node-id=112-1483&viewport=886%2C222%2C0.05&t=G2vso5JVKHaTAiqQ-9&scaling=scale-down&starting-point-node-id=112%3A1483&show-proto-sidebar=1" target="_blank" rel="noopener noreferrer">
                        <h2 class="card-title text-center">Rhythm Game Report</h2>
                        <img class="project card-image" src="img/TechnologyTimeDesignReport.png" alt="Rhythm Game Report"></img>
                    </a>
                    </div>
                    <div class="project card color-1 col-lg">
                    <a href="https://www.figma.com/proto/UCBRRy8KHQylStZ3O1kARb/Takeaway-Journal?page-id=3%3A6&type=design&node-id=13-27&viewport=762%2C400%2C0.13&t=W1Jbs3EgUiCsUl4m-9&scaling=scale-down&starting-point-node-id=13%3A27&show-proto-sidebar=1" target="_blank" rel="noopener noreferrer">
                        <h2 class="card-title text-center">Professionalism Journal</h2>
                        <img class="project card-image" src="img/ProfessionalismJournal.png" alt="Professionalism journal"></img>
                    </a>
                    </div>
                </div>
            </div>
        </section>
    </main>
    );
};
 
export default Projects;